"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useDeclaredColumns = void 0;
var _react = require("react");
var _DeclaredColumnsProvider = require("./DeclaredColumnsProvider");
var useDeclaredColumns = exports.useDeclaredColumns = function useDeclaredColumns() {
  var _useContext;
  var columns = ((_useContext = (0, _react.useContext)(_DeclaredColumnsProvider.DeclaredColumnsContext)) === null || _useContext === void 0 ? void 0 : _useContext.columns) || [];
  return columns.map(function (_ref) {
    var field = _ref.field,
      headerName = _ref.headerName;
    return {
      id: field,
      name: headerName
    };
  }).filter(function (_ref2) {
    var id = _ref2.id;
    return !['__check__', 'actions'].includes(id);
  }).filter(function (_ref3) {
    var id = _ref3.id;
    return !!id;
  });
};